import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { ASSETS } from "../../utils/config";
import Button from "../Button";

export default function AIGenerationSuccess({ closeModalHandler }) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "55vw",
        height: "60vh",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "20px",
        backgroundImage: `url(${ASSETS.bg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        paddingTop: "8vh",
      }}
    >
      <CloseIcon
        onClick={closeModalHandler}
        style={{
          height: "20px",
          width: "20px",
          position: "absolute",
          right: "8vh",
          cursor: "pointer",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginTop: "30px",
            position: "relative", // Set parent div's position to relative
            height: "100px",
            width: "100px",
          }}
        >
          <CircularProgress
            color="inherit"
            style={{
              height: "100px",
              width: "100px",
              position: "absolute",
            }} // Set CircularProgress's position to absolute
          />
          <img
            src={ASSETS.aiBot}
            alt="AiIcon"
            style={{
              position: "absolute", // Set image's position to absolute
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              height: "38px",
              width: "39px",
            }}
          />
        </div>

        <Typography
          variant="h6"
          component="h6"
          style={{
            fontFamily: "DM Sans",
            fontWeight: "500",
            fontSize: "16px",
            color: "#565556",
            textAlign: "center",
            marginTop: "30px",
            width: "50%",
          }}
        >
          Feel free to keep creating and exploring while AI creates your Wheel!
        </Typography>
        <div
          style={{
            width: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            onClick={closeModalHandler}
            style={{
              marginTop: "30px",
              width: "10vw",
              minWidth: 140,
            }}
          >
            I'm Excited!
          </Button>
        </div>
      </div>
    </Box>
  );
}
